"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return (/^[a-zA-Z]*$/.test(value)
  );
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/alpha.js
// module id = ./node_modules/vuelidate/lib/validators/alpha.js
// module chunks = 0